export default {"src":"/_next/static/media/arrow-right-circle-fill.a393633d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};